export default __webpack_public_path__ + "static/media/Rev_5.982408c8.gif";